module.exports = __webpack_public_path__ + "img/logo.66c9033e.png";